import { MpChartSettings } from '@newageerp/mp-types'

export const usageChartConfig : MpChartSettings = {
    "title": "Chart",
    "axisX": "calendar_week_year",
    "aggregate": [
        {
            "column": "order_id",
            "function": "countDistinct",
            "title": "Test",
            "chartType": "line"
        },
    ]
}

export const usageTypeChartConfig : MpChartSettings = {
    "title": "Chart",
    "axisX": "calendar_week_year",
    "axisY": "action",
    "aggregate": [
        {
            "column": "order_id",
            "function": "countDistinct",
            "title": "Test",
            "chartType": "line"
        },
    ]
}

